import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-email",
  "use": "app-channel-email-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-channel-email\"><path d=\"M29.548 7.066l-10.859 8.352a4.41 4.41 0 01-5.378 0L2.452 7.066M4 26.333h24a2 2 0 002-2v-16a2 2 0 00-2-2H4a2 2 0 00-2 2v16a2 2 0 002 2z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-email.svg
// module id = oPRM
// module chunks = 39 44